import { getOrderLayoutDetailsSchema } from '@messenger/types'
import type { GetLayoutsFromProductsNormalized } from '@messenger/types'
import { z } from 'zod'
import axios from '@/api/axios.config'

export const getOrderLayouts = async (
  orderProductDetailsId: z.infer<
    typeof getOrderLayoutDetailsSchema
  >['orderProductDetailsId'],
) => {
  return await axios.get<
    GetLayoutsFromProductsNormalized | GetLayoutsFromProductsNormalized[]
  >(`orderLayoutDetails?order_product_details_id=${orderProductDetailsId}`)
}
